export default __webpack_public_path__ + "static/favicon-6332eaa6886f82f22b687740e7ce1212.png";